import * as React from 'react';

import SubcategoryModel from 'src/model/subcategory.model';
import { ICategoryContent } from 'src/model/category.model';

import './CategoriesDropdown.scss';
import { goToCategory, categoryUrl } from 'src/utils/navigation';
import installation from 'src/assets/installationIcon';
import applianceparts from 'src/assets/installationIcon';
import tools from 'src/assets/toolsIcon';
import hvac from 'src/assets/hvacIcon';
import filters from 'src/assets/filtersIcon';
import cleaners from 'src/assets/cleanersIcon';
import brushes from 'src/assets/brushesIcon';
import flashlights from 'src/assets/flashlightsIcon';
import aircondtioned from 'src/assets/airConditionerIcon';
import hoseIcon from 'src/assets/hoseIcon';
import protectiveIcon from 'src/assets/protective';
import applianceIcon from 'src/assets/appliance';
import smallapplianceIcon from 'src/assets/smallAppliances';
import garburatorIcon from 'src/assets/garburators';
import homeCareIcon from 'src/assets/homecare';
import trainingClassIcon from 'src/assets/trainingClassIcon';
import { env } from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface ICategoriesDropdownProps {
  categories: ICategoryContent[];
  getCategories: () => void;
  t?: any;
}

interface ICategoriesDropdownState {
  nColumns: number;
  floatingIsOpen: boolean;
  categories: ICategoryContent[];
}

export class CategoriesDropdown extends React.Component<
  ICategoriesDropdownProps,
  ICategoriesDropdownState
> {
  public categoriesDropdown: any;
  private flyMenuRef: any = null;
  public categories: ICategoryContent[];

  constructor(props: any) {    
    super(props);
    this.state = {
      nColumns: 6,
      floatingIsOpen: false,
      categories: this.props.categories || []
    };
    this.categoriesDropdown = React.createRef();
    this.categories = [];
  }

  public images = [
    { category: 'installation', imageSrc: installation },
    { category: 'appliance parts', imageSrc: applianceIcon },
    { category: 'tools', imageSrc: tools },
    { category: 'Tools & Protective Wear', imageSrc: protectiveIcon },
    { category: 'hvac', imageSrc: hvac },
    { category: 'Garburators', imageSrc: garburatorIcon },
    { category: 'filters', imageSrc: filters },
    { category: 'Home Care Products', imageSrc: homeCareIcon },
    { category: 'cleaners', imageSrc: cleaners },
    { category: 'cleaning', imageSrc: cleaners },
    { category: 'brushes', imageSrc: brushes },
    { category: 'Small Appliances & Parts', imageSrc: smallapplianceIcon },
    { category: 'flashlights', imageSrc: flashlights },
    { category: 'Hoses, Connectors & Fittings', imageSrc: hoseIcon },
    { category: 'a/c', imageSrc: aircondtioned },
    { category: 'Training Classes', imageSrc: trainingClassIcon }
  ];

  /* 
    openMenu
   */
  private openMenu = (category: any) => {
    // this.setState({ floatingIsOpen: true });
    category['menuState'] = 'opened';
    this.setState({ floatingIsOpen: true });
  };

  /* 
    closeMenu
   */
  private closeMenu = () => {
    // const arr = this.state.categories;
    // arr.forEach(cat => cat.menuState = '')
    this.categories.forEach(category => (category.menuState = ''));
    this.setState({ floatingIsOpen: false });
    // this.setState({ floatingIsOpen: false });
  };

  /* 
    handleMenuState
   */
  private handleMenuState = () => {
    // this.state.floatingIsOpen ? this.closeMenu() : this.openMenu();
  };

  public componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, false);
    window.removeEventListener('resize', this.resize);
  }

  private handleClickOutside = (e: any) => {
    if (this.flyMenuRef == null || this.flyMenuRef.contains == null) {
      return;
    }
    if (this.flyMenuRef.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    // this.setState({

    // });
    if (
      this.categoriesDropdown == null ||
      this.categoriesDropdown.contains == null
    ) {
      return;
    }
    if (this.categoriesDropdown.contains(e.target)) {
      // The click is inside, continue whit what we are doing
      return;
    }
    // The click is outside, hide dropdown
    this.setState({
      // showMenu: false,
      floatingIsOpen: false
    });
  };

  public componentDidMount() {
    this.props.getCategories();
    this.resize();
    window.addEventListener('resize', this.resize);
  }

  // public handleShowMenu = () => {
  //   this.setState(prevState => {
  //     return {
  //       showMenu: !prevState.showMenu
  //     };
  //   });
  // };

  public goToCategory = (categoryId: number, subcategoryId: number) => {
    goToCategory(categoryId, subcategoryId);
    this.setState({
      // showMenu: false
    });
  };

  private resize = () => {
    let nColumns = 6;
    if (window.innerWidth < 992) {
      nColumns = 4;
    }
    this.setState({
      ...this.state,
      nColumns
    });
  };

  public handleKeyDown= (event:any) => {
    if(event.keyCode === 13) {
      this.closeMenu();
    }
  }

  private renderCategory(category: ICategoryContent, index: number) {
    
    const menuState = this.state.floatingIsOpen ? 'opened' : 'closed';
    return (
      <React.Fragment key={`category-${category.id}`}>
        <div
          className="rp-category-dropdown--category"
          onMouseOut={this.closeMenu}
          onMouseOver={this.openMenu.bind(this, category)}
          onKeyDown={this.openMenu.bind(this, category)}
        >
          <div role="button"  tabIndex={0}
            // className="rp-category-dropdown--category-name"
            className={
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? 'rp-category-dropdown--category-name-ca'
                : 'rp-category-dropdown--category-name'
            }
            onClick= {() => {category.name === 'Training Classes'?this.goToCategory(62,62) :
            this.handleMenuState()}}
            
          >
            <img role="presentation" alt=""
              className="rp-category-icon"
              src={
                this.images.find(
                  img =>
                    img.category.toLowerCase() === category.name.toLowerCase()
                )?.imageSrc
              }
            />
            {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && category.frName!== null 
            ?category.frName
            :category.name}
          </div>
          
            {category.subcategories.length > 0 && (
              <div
              className={`rp-category-dropdown-subcategories--fly-menu ${category.menuState}`}
              ref={ref => (this.flyMenuRef = ref)}
            >
              <div className="rp-category-dropdown--subcategories" onKeyDown={this.handleKeyDown}>
                {category.subcategories
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((subcategory: SubcategoryModel) => (
                    <div
                      className="rp-category-dropdown--subcategories-name"
                      key={subcategory.id}
                    >
                      <a
                        href={subcategory.id === 62 ? '../training-classes/' : categoryUrl(
                          subcategory.category.id,
                          subcategory.id
                        )}
                        onClick={() => {
                          this.goToCategory(
                            subcategory.category.id,
                            subcategory.id
                          );
                        }}
                      >
                        {(window.location.pathname === "/ca/fr/" || window.location.pathname === "/ca/fr" || window.location.pathname.includes("/ca/fr/")) && subcategory.frName!== null 
            ?subcategory.frName
            :subcategory.name}
                      </a>
                    </div>
                  ))}
              </div>
              </div>
            )}
          
        </div>
      </React.Fragment>
    );
  }

  private renderMenu() {
    // Order categories according to orderNumber
    this.categories = this.props.categories.sort(
      (a: ICategoryContent, b: ICategoryContent) => {
        return a.orderNumber - b.orderNumber;
      }
    );
    // this.categories.forEach(category => category.image = 'sadsad')

    const columns: ICategoryContent[][] = [];
    for (let i = 0; i < this.state.nColumns; i++) {
      columns.push([]);
    }

    return (
      <React.Fragment>
        <div className="rp-category-div">
          {this.props.categories.length > 0
            ? this.categories.map((column: ICategoryContent, i) => (
                <div className="category-section" key={`column-${i}`}>
                  {this.renderCategory(column, i)}
                </div>
              ))
            : i18n.t('common.noCategoriesFound')}
        </div>
      </React.Fragment>
    );
  }

  public render() {
    return <div>{this.renderMenu()}</div>;
  }
}

export default CategoriesDropdown;
